import { render, staticRenderFns } from "./bankuaijinghua.vue?vue&type=template&id=2c9bd0fb&scoped=true"
import script from "./bankuaijinghua.vue?vue&type=script&lang=js"
export * from "./bankuaijinghua.vue?vue&type=script&lang=js"
import style0 from "./bankuaijinghua.vue?vue&type=style&index=0&id=2c9bd0fb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9bd0fb",
  null
  
)

export default component.exports